import { render, staticRenderFns } from "./carCharge.vue?vue&type=template&id=5222f3e5&"
import script from "./carCharge.vue?vue&type=script&lang=js&"
export * from "./carCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports